const numberFormat = new Intl.NumberFormat("en-US");

export default numberFormat;